import { render, staticRenderFns } from "./pg-updcellphone.vue?vue&type=template&id=09f286ef&scoped=true"
import script from "./pg-updcellphone.vue?vue&type=script&lang=js"
export * from "./pg-updcellphone.vue?vue&type=script&lang=js"
import style0 from "./pg-updcellphone.vue?vue&type=style&index=0&id=09f286ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f286ef",
  null
  
)

export default component.exports